import { FC, Ref } from "react";
import cn from "classnames";

type DiscountCardSkeletonProps = {
  background?: string | null;
  shapeRef?: Ref<HTMLDivElement>;
  seamRef?: Ref<HTMLDivElement>;
};

const DiscountCardSkeleton: FC<DiscountCardSkeletonProps> = ({ background, shapeRef, seamRef }) => {
  return (
    <div className="font-inter block h-full drop-shadow-sm">
      <div
        ref={shapeRef}
        className={cn("h-full overflow-hidden", !background && "bg-background-default rounded-lg")}
        style={background ? { backgroundImage: `url(${background})`, backgroundSize: "100% 100%", backgroundRepeat: "no-repeat" } : undefined}
      >
        <div ref={seamRef} className="p-3 pb-5 md:p-3 md:pb-4">
          <div className="bg-background-minimal flex aspect-square w-full items-center justify-center overflow-hidden rounded-md p-4 md:p-6">
            <div className="bg-background-subtle aspect-square h-full animate-pulse rounded-md" />
          </div>
        </div>
        <div className="flex flex-col gap-3 px-5 p-4 pt-4 md:gap-2 md:pt-4">
          <div className="bg-background-subtle my-0.5 h-5 w-2/3 animate-pulse rounded-sm" />
          <div className="flex flex-col gap-1.5">
            <div className="bg-background-subtle h-3 w-1/3 animate-pulse rounded-sm" />
            <div className="bg-background-subtle h-4 w-1/2 animate-pulse rounded-sm" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiscountCardSkeleton;
